import PropTypes from 'prop-types';

export const UnitPosition = {
  InsideStart: 'InsideStart',
  InsideEnd: 'InsideEnd',
  OutsideEnd: 'OutsideEnd',
};

export const UnitPositionPropType = PropTypes.oneOf([UnitPosition.InsideStart, UnitPosition.InsideEnd, UnitPosition.OutsideEnd]);
